import styles from './Logo.module.css';

interface Props {
  /** Bar size for the nav, larger for the footer. */
  size?: 'sm' | 'lg';
  /** White lettering for dark grounds; the cube keeps its blues. */
  onDark?: boolean;
}

/** The Summerlin logo as on the original site: the name in its slab over the
 *  cube. Built from text and the vector cube so it stays sharp at any size. */
const Logo = ({ size = 'sm', onDark = false }: Props) => (
  <span className={`${styles.logo} ${styles[size]} ${onDark ? styles.onDark : ''}`}>
    <span className={styles.name}>Summerlin</span>
    <img className={styles.cube} src="/images/summerlin-mark.svg" alt="" width="35" height="40" />
  </span>
);

export default Logo;
